import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortItemComponent } from './sort-item/sort-item.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SortItemComponent],
  imports: [CommonModule, TranslateModule, MatIconModule],
  exports: [SortItemComponent],
})
export class SortModule {}
